/* eslint-disable react-hooks/rules-of-hooks */
import {
  ComputeCaseDto,
  ListComputeSettingsModelDto,
  ModelAreaDto,
} from '../../../../../../api';
import { hasDuplicateVariogramCase } from '../../../../utils/variogramCaseUtils';
import { normalizeObjectModelAreaId } from '../../../../utils/objectCaseUtils';

export const validateIndicator = async (
  addError: (message: string) => void,
  setIndicatorParams: (bool: boolean) => void,
  setIndicatorVariogramModel: (bool: boolean) => void,
  selectedIndicatorParameters: ListComputeSettingsModelDto[] | undefined,
  selectedVariogramModels: ListComputeSettingsModelDto[] | undefined,
) => {
  let ret = false;

  if (selectedIndicatorParameters?.length === 0) {
    addError('Indicator parameters not selected!');
    setIndicatorParams(true);
    ret = true;
  }
  if (selectedVariogramModels?.length === 0) {
    addError('Indicator variogram model not selected!');
    setIndicatorVariogramModel(true);
    ret = true;
  }
  return ret;
};

export const validateNetToGross = async (
  addError: (message: string) => void,
  setNetToGrossGrain: (bool: boolean) => void,
  setNetToGrossVariogramModel: (bool: boolean) => void,
  selectedGrainSize: ListComputeSettingsModelDto[] | undefined,
  selectedVariogramModels: ListComputeSettingsModelDto[] | undefined,
) => {
  let ret = false;

  if (selectedGrainSize?.length === 0) {
    addError('Net-to-gross grain size not selected!');
    setNetToGrossGrain(true);
    ret = true;
  }
  if (selectedVariogramModels?.length === 0) {
    addError('Net-to-gross variogram model not selected!');
    setNetToGrossVariogramModel(true);
    ret = true;
  }
  return ret;
};

export const validateContiniousParameter = async (
  addError: (message: string) => void,
  setContParamParameters: (bool: boolean) => void,
  setContParamVariogramModel: (bool: boolean) => void,
  selectedContiniousParameters: ListComputeSettingsModelDto[] | undefined,
  selectedVariogramModels: ListComputeSettingsModelDto[] | undefined,
) => {
  let ret = false;

  if (selectedContiniousParameters?.length === 0) {
    addError('Continious parameter parameters not selected!');
    setContParamParameters(true);
    ret = true;
  }
  if (selectedVariogramModels?.length === 0) {
    addError('Continious parameter variogram model not selected!');
    setContParamVariogramModel(true);
    ret = true;
  }

  return ret;
};

export const checkDuplicateType = async (
  addError: (message: string) => void,
  setFunc: (bool: boolean) => void,
  caseList: ComputeCaseDto[],
  selectedModelArea: ModelAreaDto[] | undefined,
  caseType: string,
) => {
  if (selectedModelArea && selectedModelArea.length > 0) {
    const checkDuplicateType = caseList.filter(
      (existingCase) =>
        normalizeObjectModelAreaId(existingCase.modelArea?.modelAreaId) ===
        normalizeObjectModelAreaId(selectedModelArea[0].modelAreaId),
    );

    if (caseType === 'Object' && checkDuplicateType.length > 0) {
      addError('An object case for this model area already exists!');
      setFunc(true);
      return true;
    }

    return false;
  }

  return true;
};

export const validateObjectEstimation = async (
  addError: (message: string) => void,
  setObjectEstimationModelArea: (bool: boolean) => void,
  setObjectEstimationArchel: (bool: boolean) => void,
  selectedModelArea: ModelAreaDto[] | undefined,
  selectedArchelFilter: ListComputeSettingsModelDto[] | undefined,
  isDuplicateCombination?: (modelAreaId: string, archelName: string) => boolean,
) => {
  let ret = false;

  if (selectedModelArea === undefined || selectedModelArea.length === 0) {
    addError('You must select a model area');
    setObjectEstimationModelArea(true);
    ret = true;
  }
  if (selectedArchelFilter === undefined || selectedArchelFilter.length === 0) {
    addError('Architectural element not selected!');
    setObjectEstimationArchel(true);
    ret = true;
  }

  // Duplicate combination check as safety net
  if (
    !ret &&
    isDuplicateCombination &&
    selectedModelArea &&
    selectedModelArea.length > 0 &&
    selectedArchelFilter &&
    selectedArchelFilter.length > 0
  ) {
    const areaId = selectedModelArea[0].modelAreaId ?? '';
    const archelName = selectedArchelFilter[0].name ?? '';
    if (isDuplicateCombination(areaId, archelName)) {
      addError(
        'A case with this model area and architectural element already exists!',
      );
      setObjectEstimationModelArea(true);
      setObjectEstimationArchel(true);
      ret = true;
    }
  }

  return ret;
};

export const validateModelArea = async (
  addError: (message: string) => void,
  setFunc: (bool: boolean) => void,
  selectedModelArea: ModelAreaDto[] | undefined,
) => {
  if (selectedModelArea === undefined || selectedModelArea.length === 0) {
    addError('You must select a model area');
    setFunc(true);
    return true;
  }
  return false;
};

export const validateVariogramDuplicate = async (
  addError: (message: string) => void,
  setFunc: (bool: boolean) => void,
  caseList: ComputeCaseDto[],
  currentCaseId: string,
  computeMethod: ComputeCaseDto['computeMethod'],
  selectedModelArea: ModelAreaDto[] | undefined,
  selectedParameters: ListComputeSettingsModelDto[] | undefined,
) => {
  if (
    hasDuplicateVariogramCase(
      caseList,
      currentCaseId,
      computeMethod,
      selectedModelArea,
      selectedParameters,
    )
  ) {
    addError('A variogram case with these parameters already exists!');
    setFunc(true);
    return true;
  }

  return false;
};
